import React, { useState } from 'react';
import './PumpScheduleSummary.css';
import PumpScheduleEditMode from './PumpScheduleEditMode';
import PumpScheduleDisplayMode from './PumpScheduleDisplayMode';
import { GetFullJobProfile_getJobProfile_pumpScheduleSummary as PumpScheduleSummaryData } from '../../../types/schemaTypes';

interface PumpScheduleSummaryProps {
    pumpScheduleSummaryList: PumpScheduleSummaryData[];
    isJobCompleted: boolean;
}

const PumpScheduleSummary = ({ pumpScheduleSummaryList, isJobCompleted }: PumpScheduleSummaryProps): React.ReactElement => {
    const [isEditMode, setIsEditMode] = useState(true);

    const changeEditMode = (): void => {
        setIsEditMode(!isEditMode);
    };

    return (
        <div className="PumpScheduleSummary-Container">
            {isEditMode ? (
                <PumpScheduleDisplayMode
                    pumpScheduleSummaryList={pumpScheduleSummaryList}
                    changeEditMode={changeEditMode}
                    isJobCompleted={isJobCompleted}
                />
            ) : (
                <PumpScheduleEditMode
                    pumpScheduleSummaryList={pumpScheduleSummaryList}
                    changeEditMode={changeEditMode}
                    isJobCompleted={isJobCompleted}
                />
            )}
        </div>
    );
};

export default PumpScheduleSummary;

